module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CreateNote"
  }, [_c('header', [_c('a', {
    staticClass: "backToList"
  }, [_c('span', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('span', {
    staticClass: "menuText"
  }, [_vm._v(_vm._s(undefined !== this.id ? 'Editing Note' : 'Create Note'))])]), _c('a', {
    on: {
      "click": _vm.saveNote
    }
  }, [_c('button', {
    staticClass: "saveNote"
  }, [_vm._v("Save")])])]), _c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.title),
      expression: "note.title"
    }],
    staticClass: "title",
    attrs: {
      "placeholder": "Note title is required"
    },
    domProps: {
      "value": (_vm.note.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.title = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.tag),
      expression: "note.tag"
    }],
    staticClass: "tag",
    attrs: {
      "placeholder": "Note tag"
    },
    domProps: {
      "value": (_vm.note.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.tag = $event.target.value
      }
    }
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    attrs: {
      "placeholder": "Note..."
    },
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.text = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e93f6c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateNote.vue
// module id = 226
// module chunks = 1